import { CaseClusterFieldsFragment } from '@/@generated/codegen/API';

export const getPatientCaseIndexInCluster = (
  patientCaseId: string | null | undefined,
  caseCluster: CaseClusterFieldsFragment | null
): number => {
  if (caseCluster && caseCluster.cases && patientCaseId)
    return caseCluster.cases.edges.findIndex((el) => el.node.id === patientCaseId);
  return -1;
};
